var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_tick_1348362",
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.74,
    height: 73.216,
    viewBox: "0 0 82.74 73.216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M34.875,41.459a5.537,5.537,0,1,0-8.414,7.2L39.4,63.756l4.207-3.6-4.215,3.613a5.552,5.552,0,0,0,7.828.6,5.748,5.748,0,0,0,.436-.416L90.945,23.665a5.539,5.539,0,1,0-7.546-8.11L44.056,52.171,34.875,41.459Z",
    transform: "translate(-9.969 -12.189)",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M45.612,12.069A36.487,36.487,0,0,1,71.5,22.792l.253.256-8.1,7.594a25.431,25.431,0,1,0,7.018,13.23l9.064-8.494A36.615,36.615,0,1,1,45.612,12.069Z",
    transform: "translate(-9.004 -12.069)",
    fill: "#621bc0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCheck);
export default __webpack_public_path__ + "static/media/tick-check.fa1740f75c31a34c26ee679748957ddc.svg";
export { ForwardRef as ReactComponent };